import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { BOTTOM_BAR_HEIGHT } from "modules/conversation/components/BottomMenu/MobileToolbar";
import zIndexes from "zIndexes.module.scss";

interface ITheaterStyles {
  isInBroadcast: boolean;
}

export const useStyles = makeStyles<Theme, ITheaterStyles>((theme) => ({
  root: ({ isInBroadcast }) => ({
    pointerEvents: isInBroadcast ? "all" : "none",
    top: 0,
    left: 0,
    display: "grid",
    width: "100vw",
    position: "absolute",
    gridTemplateRows: "auto 1fr",
    zIndex: zIndexes.theaterViewZIndex,
  }),
  rightPanelContainer: {
    position: "absolute",
    right: 0,
    top: 77,
    height: "calc(100vh - 187px)",
    maxWidth: "100%",
    pointerEvents: "none",
    [theme.breakpoints.down("sm")]: {
      top: 0,
      height: `calc(100vh - ${BOTTOM_BAR_HEIGHT}px)`,
    },
  },
}));
